<template>
  <div class="main user-layout-register">
    <!-- <a-descriptions
      title="显示详情"
      :column="4"
    >
      <a-descriptions-item label="高压冲水前后速度">
        {{ immGetPub05.gycsqhsd ? immGetPub05.gycsqhsd : '--' }}
      </a-descriptions-item>
      <a-descriptions-item label="高压冲水旋转速度">
        {{ immGetPub05.gycsxzsd ? immGetPub05.gycsxzsd : '--' }}
      </a-descriptions-item>
      <a-descriptions-item label="高压冲水原点等待时间">
        {{ immGetPub05.gycsydddsj ? immGetPub05.gycsydddsj : '--' }}
      </a-descriptions-item>
      <a-descriptions-item label="低泡喷洒前后速度">
        {{ immGetPub05.dppsqhsd ? immGetPub05.dppsqhsd : '--' }}
      </a-descriptions-item>
      <a-descriptions-item label="低泡喷洒旋转速度">
        {{ immGetPub05.dppsxzsd ? immGetPub05.dppsxzsd : '--' }}
      </a-descriptions-item>
      <a-descriptions-item label="低泡喷洒原点等待时间">
        {{ immGetPub05.dppsydddsj ? immGetPub05.dppsydddsj : '--' }}
      </a-descriptions-item>
      <a-descriptions-item label="高泡喷洒前后速度">
        {{ immGetPub05.gppsqhsd ? immGetPub05.gppsqhsd : '--' }}
      </a-descriptions-item>
      <a-descriptions-item label="高泡喷洒原点等待时间">
        {{ immGetPub05.gppsydddsj ? immGetPub05.gppsydddsj : '--' }}
      </a-descriptions-item>
      <a-descriptions-item label="高泡喷洒车尾等待时间">
        {{ immGetPub05.gppscwddsj ? immGetPub05.gppscwddsj : '--' }}
      </a-descriptions-item>
      <a-descriptions-item label="水蜡喷洒前后速度">
        {{ immGetPub05.slpsqhsd ? immGetPub05.slpsqhsd : '--' }}
      </a-descriptions-item>
      <a-descriptions-item label="水蜡喷洒原点等待时间">
        {{ immGetPub05.slpsydddsj ? immGetPub05.slpsydddsj : '--' }}
      </a-descriptions-item>
      <a-descriptions-item label="水蜡喷洒前后速度">
        {{ immGetPub05.slpsqhsd ? immGetPub05.slpsqhsd : '--' }}
      </a-descriptions-item>
      <a-descriptions-item label="水蜡喷洒车尾等待时间">
        {{ immGetPub05.slpscwddsj ? immGetPub05.slpscwddsj : '--' }}
      </a-descriptions-item>
      <a-descriptions-item label="强力风干前后速度">
        {{ immGetPub05.qlfgqhsd ? immGetPub05.qlfgqhsd : '--' }}
      </a-descriptions-item>
      <a-descriptions-item label="强力风干原点等待时间">
        {{ immGetPub05.qlfgydddsj ? immGetPub05.qlfgydddsj : '--' }}
      </a-descriptions-item>
      <a-descriptions-item label="强力风干车尾等待时">
        {{ immGetPub05.qlfgcwddsj ? immGetPub05.qlfgcwddsj : '--' }}
      </a-descriptions-item>
      <a-descriptions-item label="高压冲洗3前后速度">
        {{ immGetPub05.gycs3QHSD ? immGetPub05.gycs3QHSD : '--' }}
      </a-descriptions-item>
      <a-descriptions-item label="高压冲洗3旋转速度">
        {{ immGetPub05.gycs3XZSD ? immGetPub05.gycs3XZSD : '--' }}
      </a-descriptions-item>
      <a-descriptions-item label="高压冲洗3旋转速度">
        {{ immGetPub05.gycs3XZSD ? immGetPub05.gycs3XZSD : '--' }}
      </a-descriptions-item>
      <a-descriptions-item label="高压预冲洗前后速度">
        {{ immGetPub05.gyycsqhsd ? immGetPub05.gyycsqhsd : '--' }}
      </a-descriptions-item>
      <a-descriptions-item label="高压预冲洗旋转速度">
        {{ immGetPub05.gyycsxzsd ? immGetPub05.gyycsxzsd : '--' }}
      </a-descriptions-item>
      <a-descriptions-item label="高泡溶解时间">
        {{ immGetPub05.gprjsj ? immGetPub05.gprjsj : '--' }}
      </a-descriptions-item>
    </a-descriptions> -->
    <a-descriptions
      title="控制"
      :column="4"
    ></a-descriptions>
    <div>
      <a-form layout="vertical">
        <a-row :gutter="48">
          <a-col
            :md="6"
            :sm="24"
          >
            <a-form-item :label="'高压冲水1前后速度Hz(' + (immGetPub05.gycsqhsd ? immGetPub05.gycsqhsd : '--') + ')'">
              <a-input-number
                :min="5"
                :max="50"
                style="width: 100%;"
                v-model="immGetPub06.GYCSQHSD"
                placeholder="请输入5-50"
                allow-clear
              />
            </a-form-item>
          </a-col>
          <a-col
            :md="6"
            :sm="24"
          >
            <a-form-item :label="'高压冲水1旋转速度Hz (' + (immGetPub05.gycsxzsd ? immGetPub05.gycsxzsd : '--') + ')'">
              <a-input-number
                :min="9"
                :max="15"
                style="width: 100%;"
                v-model="immGetPub06.GYCSXZSD"
                placeholder="请输入9-15"
                allow-clear
              />
            </a-form-item>
          </a-col>
          <a-col
            :md="6"
            :sm="24"
          >
            <a-form-item :label="'预冲/高压水1在原点S (' + (immGetPub05.gycsydddsj ? immGetPub05.gycsydddsj : '--') + ')'">
              <a-input-number
                :min="0"
                :max="20"
                style="width:100%;"
                v-model="immGetPub06.GYCSYDDDSJ"
                placeholder="请输入0-20"
                allow-clear
              />
            </a-form-item>
          </a-col>

          <a-col
            :md="6"
            :sm="24"
          >
            <a-form-item :label="'高压预冲洗旋转速度Hz(' + (immGetPub05.gyycsxzsd ? immGetPub05.gyycsxzsd : '--') + ')'">
              <a-input-number
                :min="9"
                :max="15"
                style="width: 100%;"
                v-model="immGetPub06.GYYCSXZSD"
                placeholder="请输入9-15"
                allow-clear
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="48">
          <a-col
            :md="6"
            :sm="24"
          >
            <a-form-item :label="'高压冲水3旋转速度Hz (' + (immGetPub05.gycs3XZSD ? immGetPub05.gycs3XZSD : '--') + ')'">
              <a-input-number
                :min="9"
                :max="15"
                style="width: 100%;"
                v-model="immGetPub06.GYCS3XZSD"
                placeholder="请输入9-15"
                allow-clear
              />
            </a-form-item>
          </a-col>

          <a-col
            :md="6"
            :sm="24"
          >
            <a-form-item :label="'高压预冲洗前后速度Hz (' + (immGetPub05.gyycsqhsd ? immGetPub05.gyycsqhsd : '--') + ')'">
              <a-input-number
                :min="5"
                :max="50"
                style="width: 100%;"
                v-model="immGetPub06.GYYCSQHSD"
                placeholder="请输入5-50"
                allow-clear
              />
            </a-form-item>
          </a-col>

          <a-col
            :md="6"
            :sm="24"
          >
            <a-form-item :label="'免擦喷洒前后速度Hz (' + (immGetPub05.dppsqhsd ? immGetPub05.dppsqhsd : '--') + ')'">
              <a-input-number
                :min="5"
                :max="50"
                style="width: 100%;"
                v-model="immGetPub06.DPPSQHSD"
                placeholder="请输入5-50"
                allow-clear
              />
            </a-form-item>
          </a-col>
          <a-col
            :md="6"
            :sm="24"
          >
            <a-form-item :label="'免擦喷洒原点等待时间S(' + (immGetPub05.dppsydddsj ? immGetPub05.dppsydddsj : '--') + ')'">
              <a-input-number
                :min="0"
                :max="20"
                style="width: 100%;"
                v-model="immGetPub06.DPPSYDDDSJ"
                placeholder="请输入0-20"
                allow-clear
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="48">
          <a-col
            :md="6"
            :sm="24"
          >
            <a-form-item :label="'免擦喷洒旋转速度S (' + (immGetPub05.dppsxzsd ? immGetPub05.dppsxzsd : '--') + ')'">
              <a-input-number
                :min="0"
                :max="20"
                style="width: 100%;"
                v-model="immGetPub06.DPPSXZSD"
                placeholder="请输入0-20"
                allow-clear
              />
            </a-form-item>
          </a-col>

          <a-col
            :md="6"
            :sm="24"
          >
            <a-form-item :label="'高泡溶解时间S(' + (immGetPub05.gprjsj ? immGetPub05.gprjsj : '--') + ')'">
              <a-input-number
                :min="0"
                :max="999"
                style="width: 100%;"
                v-model="immGetPub06.GPRJSJ"
                placeholder="请输入0-999"
                allow-clear
              />
            </a-form-item>
          </a-col>
          <a-col
            :md="6"
            :sm="24"
          >
            <a-form-item :label="'高泡喷洒前后速度Hz (' + (immGetPub05.gppsqhsd ? immGetPub05.gppsqhsd : '--') + ')'">
              <a-input-number
                :min="5"
                :max="50"
                style="width: 100%;"
                v-model="immGetPub06.GPPSQHSD"
                placeholder="请输入5-50"
                allow-clear
              />
            </a-form-item>
          </a-col>

          <a-col
            :md="6"
            :sm="24"
          >
            <a-form-item :label="'高泡喷洒原点等待时间S (' + (immGetPub05.gppsydddsj ? immGetPub05.gppsydddsj : '--') + ')'">
              <a-input-number
                :min="0"
                :max="20"
                style="width: 100%;"
                v-model="immGetPub06.GPPSYDDDSJ"
                placeholder="请输入0-20"
                allow-clear
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="48">
          <a-col
            :md="6"
            :sm="24"
          >
            <a-form-item :label="'高泡喷洒车尾等待时间S (' + (immGetPub05.gppscwddsj ? immGetPub05.gppscwddsj : '--') + ')'">
              <a-input-number
                :min="0"
                :max="20"
                style="width: 100%;"
                v-model="immGetPub06.GPPSCWDDSJ"
                placeholder="请输入0-20"
                allow-clear
              />
            </a-form-item>
          </a-col>

          <a-col
            :md="6"
            :sm="24"
          >
            <a-form-item :label="'水蜡喷洒前后速度Hz (' + (immGetPub05.slpsqhsd ? immGetPub05.slpsqhsd : '--') + ')'">
              <a-input-number
                :min="5"
                :max="50"
                style="width: 100%;"
                v-model="immGetPub06.SLPSQHSD"
                placeholder="请输入5-50"
                allow-clear
              />
            </a-form-item>
          </a-col>
          <a-col
            :md="6"
            :sm="24"
          >
            <a-form-item :label="'水蜡喷洒原点等待时间S (' + (immGetPub05.slpsydddsj ? immGetPub05.slpsydddsj : '--') + ')'">
              <a-input-number
                :min="0"
                :max="20"
                style="width: 100%;"
                v-model="immGetPub06.SLPSYDDDSJ"
                placeholder="请输入0-20"
                allow-clear
              />
            </a-form-item>
          </a-col>

          <a-col
            :md="6"
            :sm="24"
          >
            <a-form-item :label="'水蜡喷洒车尾等待时间S (' + (immGetPub05.slpscwddsj ? immGetPub05.slpscwddsj : '--') + ')'">
              <a-input-number
                :min="0"
                :max="20"
                style="width: 100%;"
                v-model="immGetPub06.SLPSCWDDSJ"
                placeholder="请输入0-20"
                allow-clear
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="48">
          <a-col
            :md="6"
            :sm="24"
          >
            <a-form-item :label="'强力风干前后速度Hz (' + (immGetPub05.qlfgqhsd ? immGetPub05.qlfgqhsd : '--') + ')'">
              <a-input-number
                :min="5"
                :max="50"
                style="width: 100%;"
                v-model="immGetPub06.QLFGQHSD"
                placeholder="请输入5-20"
                allow-clear
              />
            </a-form-item>
          </a-col>

          <a-col
            :md="6"
            :sm="24"
          >
            <a-form-item
              :label="'强力风干原点等待时间S (' + (immGetPub05.qlfgydddsj || immGetPub05.qlfgydddsj == 0 ? immGetPub05.qlfgydddsj : '--') + ')'"
            >
              <a-input-number
                :min="0"
                :max="20"
                style="width: 100%;"
                v-model="immGetPub06.QLFGYDDDSJ"
                placeholder="请输入0-20"
                allow-clear
              />
            </a-form-item>
          </a-col>
          <a-col
            :md="6"
            :sm="24"
          >
            <a-form-item :label="'强力风干车尾等待时S (' + (immGetPub05.qlfgcwddsj ? immGetPub05.qlfgcwddsj : '--') + ')'">
              <a-input-number
                :min="0"
                :max="20"
                style="width: 100%;"
                v-model="immGetPub06.QLFGCWDDSJ"
                placeholder="请输入0-20"
                allow-clear
              />
            </a-form-item>
          </a-col>

          <a-col
            :md="6"
            :sm="24"
          >
            <a-form-item :label="'高压冲水3前后速度Hz (' + (immGetPub05.gycs3QHSD ? immGetPub05.gycs3QHSD : '--') + ')'">
              <a-input-number
                :min="5"
                :max="50"
                style="width: 100%;"
                v-model="immGetPub06.GYCS3QHSD"
                placeholder="请输入5-50"
                allow-clear
              />
            </a-form-item>
          </a-col>
        </a-row>

        <div>
          <a-button
            type="primary"
            @click="handleSubmit"
          >
            提交
          </a-button>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import { getDev, controlPublic, devDetail, subDate } from '@/api/device'
let client = null
export default {
  name: 'Register',
  // components: { videoPlayer },
  data () {
    return {
      devId: '',
      info: {},
      immGetPub05: {},
      immGetPub06: {},
      devInfo: {},
    }
  },
  computed: {},
  created () {
    let index = window.location.href.indexOf('id=')
    // console.log(window.location.href.substring(index + 3), '大大大大大')
    this.devId = window.location.href.substring(index + 3)
    // 查询详情
    this.getDetail()
    this.getDevDetail()
  },
  beforeDestroy () {
    client.end()
  },
  methods: {
    getDetail () {
      getDev({ devId: this.devId }).then(res => {
        console.log(res, '滴滴滴滴滴滴1111');
        res = res.data
        this.info = res
        this.immGetPub05 = res.immGetPub05
        this.immGetPub06 = res.immGetPub06
      })
    },
    // 提交数据
    handleSubmit () {
      this.immGetPub06.devId = this.devId
      subDate(this.immGetPub06).then(res => {
        this.$message.success('提交成功')
      })
    },
    getDevDetail () {
      devDetail({ id: this.devId }).then(res => {
        res = res.data
        this.devInfo = res
        // this.subscribe = res.devCode + '/immGetSub01'
        this.subscribe = [res.devCode + '/web/pub/01', res.devCode + '/web/pub/02']
        console.log(this.subscribe, 'this.subscribethis.subscribethis.subscribe');
        this.connectMqtt()
      })
    },
    /**
 * @desc mqtt连接
 * @author 刘
 * @time 2023年06月02日 18:31:19 星期五
 */
    connectMqtt () {
      const that = this
      var mqtt = require('mqtt/dist/mqtt.js')
      // client = mqtt.connect('ws://emqx.zzcyi.cn:8083/bao/bao-dev')
      // const mqttUrl = 'ws://139.196.79.66:7084/bao/bao-dev'
      const mqttUrl = 'ws://139.196.79.66:7084/mqtt'
      // client = mqtt.connect('ws://47.104.102.88:8083/bao/bao-dev')
      client = mqtt.connect(mqttUrl, {
        protocolVersion: 4,
        reconnectPeriod: 100,
        connectTimeout: 30 * 1000,
        resubscribe: true,
        keepalive: 3,
        clientId:
          'mqttjs_' +
          Math.random()
            .toString(16)
            .substr(2, 8)
      })
      client.on('connect', function () {
        console.log('on connect', new Date().getTime())
        console.log('主题>>>>', that.subscribe)
        client.subscribe(that.subscribe, function (err, granted) {
          console.log('订阅主题>>>>>err>>>>', err, that.subscribe)
          console.log('订阅主题>>>>>granted>>>>', granted)
          if (!err) {
            console.log('订阅成功>>>>')
          }
        })
      }).on('reconnect', function () {
        // uni.showLoading({
        // 	title:'加载中...',
        // 	mask:true
        // })
        // setTimeout(function() {
        // 	uni.hideLoading()
        // }, 3000);
        console.log('重新连接', new Date().getTime())
      }).on('close', function (err) {
        // that.setIsMqttConnect(false)
        console.log('链接断开>>>>', err)
      }).on('error', function (err) {
        console.log('on error', err)
      }).on('end', function () {
        // that.setIsMqttConnect(false)
        console.log('on end')
      }).on('message', function (topic, message) {
        console.log('mqtt消息', message.toString())
        // alert(message.toString())
        // that.getDetail()
        let num = JSON.parse(message.toString());
        console.log(num, 'numnumnumnum====');
        if (num.topic.indexOf('/web/pub/05') !== -1) {
          that.immGetPub05 = num
          that.$forceUpdate()
          // console.log(that.immGetPub01, 'that.immGetPub01that.immGetPub01');
        } else if (num.topic.indexOf('/web/pub/06') !== -1) {
          that.immGetPub06 = num
          that.$forceUpdate()
          // console.log(that.immGetPub02, 'that.immGetimmGetPub02immGetPub02immGetPub02Pub01that.immGetPub01');
        }
        // try {
        //   const messageObj = JSON.parse(message)
        //   console.log('接受到的消息>>>', messageObj)
        //   // logType为"sendToDev"--向设备发送信息
        //   // logType为"devReply"--设备回复
        //   // logType为"devLogin"--设备上线
        //   that.setData(messageObj)
        // } catch (e) {
        //   // TODO handle the exception
        // }
      })
    },
    // 点击控制
    handleControl (e, url) {
      console.log(e, '滴滴滴滴滴滴');

      let that = this
      console.log(that.devId, ' that.devId that.devId');
      this.$confirm({
        title: '提示',
        content: e,
        onOk () {
          controlPublic(url, { devId: that.devId }).then(res => {

          })
        },
        onCancel () { },
      });
    },
    // 点击长按事件
    handleDown (e, url) {
      // 设置一个定时器，如果用户持续按住，则执行长按操作
      if (!this.open) return this.$message.error('请检查现场情况在打开锁')
      if (this.longPressTimer) {
        clearTimeout(this.longPressTimer);
        this.longPressTimer = null
      }
      this.longPressTimer = setTimeout(() => {
        // 执行长按后的操作
        // console.log('Long press triggered');
        this[e] = true
        if (e == 's3' || e == 's4' || e == 's5' || e == 's6') {
          // s3 向前 后 正 反
          controlPublics(url, { id: this.devId, open: true }).then(res => {

          })
        } else if (e == 's1') {
          // s1 升 
          controlPublic(url, { devId: this.devId, YCMSS: true }).then(res => {

          })
        } else {
          // s2 降
          controlPublic(url, { devId: this.devId, YCMXJ: true }).then(res => {

          })
        }
        // if (e == 1) {
        //   console.log(this.s1, '对对对的多多多急急急吗');
        // }
        // clearTimeout(this.longPressTimer);

      }, 800); // 长按1秒
    },
    // 结束长按
    handleUp (e, url) {
      console.log('handleUp>>>>');
      if (!this.open) return
      // 清除定时器
      clearTimeout(this.longPressTimer);
      // if (e == 1) {
      //   this.s1 = false
      // }
      if (!this[e]) return
      this[e] = false
      if (e == 's3' || e == 's4' || e == 's5' || e == 's6') {
        // s3 向前 后 正 反
        controlPublics(url, { id: this.devId, open: false }).then(res => {
        })
      } else if (e == 's1') {
        // s1 升 
        controlPublic(url, { devId: this.devId, YCMSS: false }).then(res => {

        })
      } else {
        // s2 降
        controlPublic(url, { devId: this.devId, YCMXJ: false }).then(res => {

        })
      }
      this.longPressActive = false
    },
  }
}
</script>

<style lang="less" scoped>
.main {
  height: 80vh;
}
</style>
